import { useFormContext } from 'react-hook-form';
import { Grid2, Typography, Alert } from '@mui/material';

import { FormField, FormFieldType, API_FIELDS_APPLICATION as APPLICATION } from '@enroller/admissions-components';

import { TitledSection } from '../../../layout/TitledSection';
import { yesNoOptions } from '../../../constants/yesNoOptions';

import { HousingFormValues, HOUSING_PAGE_SECTIONS } from './HousingFormValues';

const sameSexCoupleOptions = [
  { label: 'No', value: 'No' },
  { label: 'Female couple', value: 'Female couple' },
  { label: 'Male couple', value: 'Male couple' },
  { label: 'Either female or male couple', value: 'Either female or male couple' },
];

const singleParentOptions = [
  { label: 'No', value: 'No' },
  { label: 'Female single parent', value: 'Female single parent' },
  { label: 'Male single parent', value: 'Male single parent' },
  { label: 'Either female or male single parent', value: 'Either female or male single parent' },
];

export const PlacementSection = () => {
  const { control } = useFormContext<HousingFormValues>();
  const section = HOUSING_PAGE_SECTIONS.placement;

  return (
    <TitledSection title="Placement">
      <Grid2>
        <Alert variant="outlined" severity="info">
          <Typography variant="body2">
            Please check the boxes below to indicate if you are open to these types of placements. Please note that even if you do not select these options, you
            may still be offered a placement like this after your application is accepted. We encourage you to be open-minded. Families come in all shapes and
            sizes and you can have a positive experience in any family type.
          </Typography>
        </Alert>
      </Grid2>

      <Grid2 size={12}>
        <FormField
          control={control}
          name={`${section}.${APPLICATION.acceptDoublePlacement}`}
          type={FormFieldType.Radio}
          options={yesNoOptions}
          label="Will you accept a double placement with another exchange student?"
        />
      </Grid2>

      <Grid2 size={12}>
        <FormField
          control={control}
          name={`${section}.${APPLICATION.acceptSingleHost}`}
          type={FormFieldType.Radio}
          options={singleParentOptions}
          label="Will you accept a placement with a single host? (*If you accept a single host placement, you will be required to sign the single host placement student and natural parent consent document prior to acceptance of your application.)"
        />
      </Grid2>

      <Grid2 size={12}>
        <FormField
          control={control}
          name={`${section}.${APPLICATION.acceptSameSexCouple}`}
          type={FormFieldType.Radio}
          options={sameSexCoupleOptions}
          label="Will you accept a placement with a same-sex couple?"
        />
      </Grid2>

      <Grid2 size={12}>
        <FormField
          control={control}
          name={`${section}.${APPLICATION.acceptSmallSchool}`}
          type={FormFieldType.Radio}
          options={yesNoOptions}
          label="Will you accept a placement in a small school (under 100 students in grades 9 through 12)?"
        />
      </Grid2>
    </TitledSection>
  );
};
